import React from 'react'
import axios from 'axios'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import langM from './lang'
import Toast from 'src/component/Toast'
import { apiLadiesRegister } from 'src/helper/ladies'
import http from 'src/helper/http'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
import Msg from 'src/component/Message'
import Loading from 'src/component/LoadingComp'
import { chooseImage as handleChooseImage, uploadFile as uploadFileImg } from '../../../helper/webviewFun'
import brower from '../../../helper/brower'
const rewardsRules = [
  {
    gold: '1',
    medal: '3',
    ratio: '5',
    time: "40k",
    sn: "6k",
  },
  {
    gold: '2',
    ratio: '14',
    medal: '10',
    time: "200k",
    sn: "15k",
  },
  {
    gold: '3',
    ratio: '14',
    medal: '10',
    time: "800k",
    sn: "40k",
  },
]
@inject('store')
@observer


export default class LadiesRegister extends React.Component {
  constructor(props) {
    super(props)
    // this.ladiesStore = this.props.store.register('activity/ladies')
    setDocumentTitle("Queen Register")
  }
  state = {
    lang:langM.en,
    language: "en",
    ruleStatus: false,
    ruleStatus1: false,
    ruleStatus2: false,
    recordStatus: false,
    time: 0,
    toastContent: '',
    userinfo: {},
    introduction: "",
    imgUrl: "",
    imagePath: "",
    imageBase: "any",
    toastContent: '',
    res: {},
    failMsg: "",
    formData: "",
    isLoading: false,
    picList: [],
    picShowState: false,
    uid: '',
  }

  async initLang() {
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log("language", language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
  }
  async componentWillMount() {
    this.initLang()
    let uid = await setUidToken(this.props.location.query)
    this.setState({
      uid
    })
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    let d = await http.post('/web/MyAccountInfo')
    this.setState({
      userinfo: d && d.res
    })
  }


  async changeValue(e, name) {
    this.setState({
      introduction: e.target.value
    })
  }

  async androidUpload() {
    this.setState({
      imgUrl: "",
      formData: "",
      imagePath: "",
      picList: []
    })

    // 安卓无法调用input、upload
    // if (brower.isIphone()) {
    //   return
    // }
    // 限定最大图片
    let maxAdd = 1
    let mapData = {
      count: maxAdd > 0 ? maxAdd : 0,
      sizeType: 'compressed',
      mp4Enabled: true,
      os: brower.isAndroid() ? 2 : 1
    }
    try {
      // 推入图片功能
      await handleChooseImage(mapData, async (pic) => {
        // 一张一张推入功能
        let list = this.state.picList
        for (let i = 0; i < pic.length; i++) {
          list.push(pic[i])
        }
        await this.setState({
          imagePath: list && list[0] && list[0].imageData,
          picList: list
        })

        let map = this.state.picList
        let map2 = []
        for (let i = 0; i < map.length; i++) {
          map2.push({
            filePath: map[i].path,
            fileType: map[i].image
          })
        }
        if (map2.length > 0) {
          await uploadFileImg(map2, (d) => {
            let list = d
            let arr = []
            this.setState({
              imgUrl: list && list[0] && list[0].url
            })
            return
          })
        }
      })
    } catch (error) {
      console.error(error)
    } finally {
    }

  }

  async onImgFileFn(e) {
    e.preventDefault()
    console.log(e.target.files)
    //获取图片文件，图片类型，图片大小
    const file = e.target.files[0]
    const type = file && file.type
    const size = file && file.size
    const regularType = ['image/png', 'image/jpg', 'image/jpeg']
    //图片类型限制
    if (regularType.indexOf(type.toLowerCase()) === -1) {
      this.refs.msg.show('Only supports PNG or JPG images!')
      return false
    }
    //图片大小限制
    if (size && size > 5242880) {
      // 5 * 1024 * 1024，size的单位是字节
      this.refs.msg.show('The image size should less than 5M!')
      return false
    }
    //图片文件转成base64格式
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      this.setState({
        imagePath: reader.result
      })
    }
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    this.setState({
      formData: formData
    })
    e.target.value = '' // 清空上次图片数据，保证可以选择同一张图片
  }

  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }

  hideRule1 = async (status) => {
    this.setState({
      ruleStatus1: status
    })
    if (status) {
      history.push(`/activity/ladies`)
    }
  }

  hideRule2 = async (status) => {
    this.setState({
      ruleStatus2: status
    })
  }

  apply = async (id) => {
    if (this.state.userinfo.wealthLv < 10 && this.state.userinfo.charmLv < 10) {
      this.refs.msg.show(this.state.lang.lvFail)
      return
    }
    if (this.state.introduction == "") {
      this.refs.msg.show(this.state.lang.fail)
      return
    }
    try {
      this.setState({
        isLoading: true
      })

      // 判断当前是否有上传图片
      if (this.state.formData) {
        const { accesstoken, uid } = localstorage.get('userInfo')
        const config = {
          headers: {
            'X-Uid': uid || this.state.userinfo.uid || this.props.location.query.uid,
            'X-Token': accesstoken || this.props.location.query.accesstoken
          }
        }
        await axios.post("/web/upload", this.state.formData, config)
          .then(res => {
            this.setState({
              imgUrl: res.res
            })
          })
      }

      // 如果没有图片，不予通过
      // if (!this.state.imgUrl) {
      //   this.refs.msg.show(this.state.lang.checkPic)
      //   return
      // }

      // 注册接口
      this.setState({
        res: await apiLadiesRegister(this.state.imgUrl, this.state.introduction)
      })

      // 注册结果
      let res = this.state.res
      if (res && res.res == 1) {
        this.refs.msg.show(this.state.lang.noSex)
        return
      } else if (res && res.res == 2) {
        this.refs.msg.show(this.state.lang.hadSuc)
        return
      } else {
        this.hideRule1(true)
      }
    } catch (error) {
      console.error(error)
      return new Error(error)
    } finally {
      this.setState({
        isLoading: false
      })
    }

  }

  /**
  * @description 清空图片参数
  */
  clearImg(nu, e) {
    e.stopPropagation()
    this.setState({
      imgUrl: "",
      formData: "",
      imagePath: "",
      picList: []
    })
  }

  handleShowPic(e, state) {
    e.stopPropagation()
    this.setState({
      picShowState: state
    })
  }

  render() {
    let { language, lang, uid } = this.state
    return (
      <div className={`ladies-register ${language == 'ar' && 'arlang'}`}>

        <div className="pic-show" style={{ display: `${this.state.picShowState ? "block" : "none"}` }} onClick={(e) => { this.handleShowPic(e, false) }}>
          <div className="pic-box">
            <img src={this.state.imagePath} alt="" />
          </div>
        </div>

        <Msg ref="msg" />
        <Loading show={this.state.isLoading} />

        <div className='rules'>
          <span>{this.state.lang.ruleText}</span>
          <div className={`content ${language == 'ar' && 'arlang'}`} dangerouslySetInnerHTML={{ __html: lang.rule }}></div>
        </div>
        <div className="rules-table">
          <table>
            <thead>
              <tr>
                <td>{lang.trOne}</td>
                <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trTwo}</td>
                <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trThree}</td>
                <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trFour}</td>
                <td style={{ borderLeft: '0.01rem solid #ffffff' }}>{lang.trFive}</td>
              </tr>
            </thead>

            {rewardsRules.map((item, index) => {
              return (
                <tbody key={index}>
                  <tr>
                    <td>{item.gold}</td>
                    <td>{item.medal}</td>
                    <td>{item.ratio}</td>
                    <td>{item.time}</td>
                    <td>{item.sn}</td>
                  </tr>
                </tbody>
              )
            })}

          </table>
        </div>
        <div className='form-box'>
          <div className='input-box' >
            <div><b>* </b> User ID</div>
            <input type="text" name='uid' value={this.state.userinfo.duid} readOnly='readonly' />
          </div>
          <div className='input-box'>
            <span><b>* </b> User Level</span>
            <input className='level' type="text" name='level' value={`W: ${this.state.userinfo.wealthLv} C: ${this.state.userinfo.charmLv} A: ${this.state.userinfo.activLv} `} readOnly='readonly' />
          </div>

          <div className='text-input'>
            <span>*</span><textarea placeholder={this.state.lang.introduce} onChange={(event, name) => this.changeValue(event, "des")}></textarea>
          </div>
          <div className='input-box input-image'>
            <span> Proof of Comment</span>
          </div>
          <div className="select-img-input-outer">
            <label className='select-img-input' htmlFor="upload" onClick={() => { this.androidUpload() }}>
            </label>
            <div className='display-img' style={{ display: `${this.state.imagePath != "" ? "block" : "none"}` }}>
              <img style={{ display: `${this.state.imagePath ? "block" : "none"}` }} className='del' onClick={(e) => { this.clearImg(1, e) }} src="/img/activity/ladies/del.png" />
              <img style={{ display: `${this.state.imagePath ? "block" : "none"}` }} className='imagePath' onClick={(e) => { this.handleShowPic(e, true) }} src={this.state.imagePath} />
            </div>
          </div>
          <input
            id='upload'
            className='upload'
            onChange={(event) => this.onImgFileFn(event)}
            type='file'
            name='fileSelect'
            accept='image/*'
            multiple="mutiple"
          />

          <div className='apply' onClick={this.apply.bind(this, 1)} >{this.state.lang.apply}</div>

          {/* <div className='display-img' style={{ display: `${this.state.imagePath != "" ? "block" : "none"}` }}>
            <img style={{ display: `${this.state.imagePath ? "block" : "none"}` }} className='del' onClick={this.clearImg.bind(this, 1)} src="/img/activity/ladies/del.png" />
            <img style={{ display: `${this.state.imagePath ? "block" : "none"}` }} className='imagePath' src={this.state.imagePath} />
          </div> */}
        </div>

        <Toast language={language} lang={this.state.lang} ref="toast" id="toast" toastContent={this.state.toastContent} />

        {/* 规则页面 */}
        {/* <div className="rules" onClick={this.hideRule1.bind(this, true)}>
          {this.state.lang.ruleText}
        </div> */}

        {
          this.state.ruleStatus1 && <div className="loading" onClick={this.hideRule1.bind(this, false)}></div>}
        {
          this.state.ruleStatus1 &&
          (
            <div className={`popRule animationBeBigCenter`} >
              <div>{this.state.lang.comp}</div>
              <span onClick={this.hideRule1.bind(this, false)}>OK</span>
            </div>
          )
        }


        {this.state.ruleStatus2 && <div className="loading" onClick={this.hideRule2.bind(this, false)}></div>}
        {this.state.ruleStatus2 && (
          <div className={`popRule animationBeBigCenter`} >
            <div>{this.state.failMsg}</div>
            <span onClick={this.hideRule2.bind(this, false)}>OK</span>
          </div>
        )}


      </div>
    )
  }

}


// WEBPACK FOOTER //
// src/pages/activity/ladiesregister/index.js